import React from 'react'
import { Typography } from 'antd'
import { CustomModal } from 'src/components'
import { useTranslation } from 'next-i18next'
import { resetChangePasswordState } from 'src/features'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
const { Title } = Typography

const ChangePasswordErrorModal = ({ isModalVisible, setIsModalVisible }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { errorMessage } = useAppSelector((state) => state.users.changePassword)

  const handleCancel = () => {
    dispatch(resetChangePasswordState())
    setIsModalVisible(false)
  }

  const getMessage = () => {
    return errorMessage?.endsWith('OldPasswordIncorrect') ? t('settings.OldPasswordIncorrect') : errorMessage
  }

  return (
    <>
      <CustomModal
        title={t('general.ErrorTitle')}
        footer={null}
        open={isModalVisible}
        onCancel={handleCancel}
      >
        <Title level={5} type='secondary'>
          {getMessage()}
        </Title>
      </CustomModal>
    </>
  )
}
export default ChangePasswordErrorModal
